import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  placeholder?: string;
}

export function SearchBar({ value, onChange, onSearch, placeholder = "搜索图书名称或简介..." }: SearchBarProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch?.();
    }
  };

  return (
    <div className="flex items-center gap-2 flex-1 max-w-xl">
      <div className="relative flex-1">
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="pr-10 bg-background border-input"
        />
      </div>
      <Button 
        size="icon" 
        variant="outline"
        onClick={onSearch}
        className="shrink-0"
      >
        <Search className="h-4 w-4" />
      </Button>
    </div>
  );
}
